import React from 'react';
import StickyNote from './sticky-note/sticky-note';
import { useStickyData } from '../shared';
import Menus from './menus/menus';
import './header.scss';
export default function Header() {
    const stickyData = useStickyData();
    return (React.createElement("div", { className: "page-header" },
        React.createElement(StickyNote, { stickyData: stickyData }),
        React.createElement(Menus, null)));
}
